module.exports = __webpack_public_path__ + "img/waistband_width.4a1d5072.png";